import * as React from 'react';

const DashData: React.FC = () => {
    return (
        <div className="grid gap-[10%] lg:grid-cols-4 grid-cols-2 sm:w-full w-[100%] mb-10 sm:mt-0 mt-16">
            <div className="px-4 py-5 bg-white rounded-lg shadow sm:text-start text-center">
                <div className="mt-1 text-3xl font-semibold text-gray-900">
                    42
                </div>
                <div className="text-sm font-medium text-[#8B8686] truncate">
                    Bookings
                </div>
            </div>
            <div className="px-4 py-5 bg-white rounded-lg shadow sm:text-start text-center">
                <div className="mt-1 text-3xl font-semibold text-gray-900">
                    100
                </div>
                <div className="text-sm font-medium text-[#8B8686] truncate">
                    CLients Expected
                </div>
            </div>
            <div className="px-4 py-5 bg-white rounded-lg shadow sm:text-start text-center">
                <div className="mt-1 text-3xl font-semibold text-gray-900">
                    67
                </div>
                <div className="text-sm font-medium text-[#8B8686] truncate">
                    Rooms taken
                </div>
            </div>
            <div className="px-4 py-5 bg-white rounded-lg shadow sm:text-start text-center">
                <div className="mt-1 text-3xl font-semibold text-gray-900">
                    120, 000$
                </div>
                <div className="text-sm font-medium text-[#8B8686] truncate">
                    Money paid
                </div>
            </div>
        </div>
    )
}
export default DashData;